<div class="layout horizontal left middle"
     [ngStyle]="{'cursor': clickable ? 'pointer' : null}">
    <app-icon [id]="iconId"></app-icon>
    <span style="margin-inline-start: 4px;">{{label}}</span>
</div>